<div #modalRef class="modal fade" [id]="modalId" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered custom-width">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ title }}</h5>
        <button *ngIf="dismissible" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body text-center custom-modal-body">
        <p [innerHTML]="message"></p>
      </div>
      <div class="modal-footer justify-content-center">
        <button *ngIf="!showConfirmOnly"
                type="button"
                class="btn btn-outline"
                [disabled]="!dismissible"
                (click)="onCancel();">
          {{ cancelButtonText }}
        </button>
        <button type="button"
                class="btn btn-primary"
                [disabled]="!dismissible"
                (click)="onConfirm();">
          {{ confirmButtonText }}
        </button>
      </div>
    </div>
  </div>
</div>
